import { Typography } from '@mui/material';
import * as styles from './SimilarTracksModal.styles';

interface ShortcutHintProps {
  label: string;
}

export const ShortcutHint = ({ label }: ShortcutHintProps) => (
  <Typography variant="caption" color="text.disabled" sx={styles.shortcutHint}>
    Press {label.toUpperCase()}
  </Typography>
);
